import { render, staticRenderFns } from "./ConnectionFail.vue?vue&type=template&id=ba4294ee&scoped=true&"
import script from "./ConnectionFail.vue?vue&type=script&lang=js&"
export * from "./ConnectionFail.vue?vue&type=script&lang=js&"
import style0 from "./ConnectionFail.vue?vue&type=style&index=0&id=ba4294ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4294ee",
  null
  
)

export default component.exports